import axios from 'axios';
import { useState, useEffect } from 'react';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';

const useGetData = () => {
  const date = useQuery('date');
  const [moduleData, setModuleData] = useState<any>([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [render, setParentRender] = useState(false);
  const [renderforUpdate, setRenderforUpdate] = useState(false);
  const [machineData, setMachineData] = useState([]);

  
  const handleImport = async () => {
    try {
      const response = await axios.get(
        `/api/downTimeAnalysisRoute/importMonthlyData/getData?date=${date}`
      );
  
      setModuleData(response?.data); // Replace moduleData instead of modifying it
    } catch (error) {
      console.error("Error fetching import data:", error);
    }
  };
  
  useEffect(() => {
    handleImport();
    if (!date) return;
    // const handleApi = async () => {
    //   setIsLoading(true);
    //   axios
    //     .get(`${moduleConstant.apiConstant}/${date}`)
    //     .then((response) => {
    //       console.log("moduledata in useGetData is ",response?.data);
    //       setModuleData(response?.data);
    //       setIsLoading(false);
    //     })
    //     .catch((err) => {
    //       setIsLoading(false);
    //       setModuleData([]);
    //       setError(err);
    //     });
    // };

    // handleApi();
    setIsLoading(false);
  }, [date, renderforUpdate]);

  return {
    error,
    moduleData,
    setModuleData,
    isLoading,
    setParentRender,
    setRenderforUpdate,
    machineData,
    handleImport,
  };
};

export default useGetData;
